
document.addEventListener('DOMContentLoaded', function() {
  // Step 1: Set up the #waykar-banner for zoom-in
  const imageDiv = document.querySelector('#waykar-banner');
  const heading = document.querySelector('#aboutus-heading');

  
  // Apply fade-in effect to the #waykar-banner
  // setTimeout(function() {
  //   imageDiv.classList.add('fade-in'); // Start fading in
  // }, 1000); // Slight delay for smooth effect
  
  // // Zoom-in effect when fade in done
  // imageDiv.addEventListener('transitionend', function(e) {
  //   if (e.propertyName === 'opacity') { // Check if fade-in has completed
  //     imageDiv.classList.add('zoom-in'); // Start zooming in after fade-in
  //   }
  // });

  // // After the zoom-in finishes, fade in the heading
  // imageDiv.addEventListener('transitionend', function(e) {
  //   if (e.propertyName === 'transform') {
  //     heading.style.display = 'block';
  //     heading.classList.add('show'); // Adds the fade-in effect for the h1
  //   }
  // });

  // // Scrolling effect
  // const maxScroll = document.documentElement.scrollHeight - window.innerHeight; // Maximum scrollable height
  // const minWidth = 1320; // Minimum width in pixels

  // window.addEventListener('scroll', function() {
  //   // Calculate scroll percentage
  //   const scrollTop = window.scrollY; // Current scroll position
  //   const scrollPercent = scrollTop / maxScroll; // Percentage of scroll

  //   // Calculate the new width based on scroll
  //   const newWidth = Math.max(minWidth, window.innerWidth - (window.innerWidth - minWidth) * scrollPercent);

  //   // Apply the new width to the image-div
  //   imageDiv.style.width = newWidth + 'px';
  // });


  /* Company Hisory Section - About us page*/
  // const circle = document.querySelector('.progress-ring__circle');
  // const radius = circle.r.baseVal.value;
  // const circumference = 2 * Math.PI * radius;
  
  // circle.style.strokeDasharray = `${circumference} ${circumference}`;
  // circle.style.strokeDashoffset = circumference;
  
  // function setProgress(percent) {
  //   const offset = circumference - (percent / 100) * circumference;
  //   circle.style.strokeDashoffset = offset;
  // }
  
  // const container = document.querySelector('.container');
  
  // document.addEventListener('scroll', () => {
  //   const containerTop = container.getBoundingClientRect().top;
  //   const containerHeight = container.offsetHeight;
  //   const windowHeight = window.innerHeight;
  
  //   const scrollPercent = Math.min(
  //     Math.max((windowHeight - containerTop) / containerHeight, 0),
  //     1
  //   ) * 100;
  
  //   setProgress(scrollPercent);
  // });
});
